import ApiServiceBase from "@/services/api/apiServiceBase";
import {normalizePaginated} from "@/services/api/normalizeProfile";

/** Module-level page cursor — ApiService.UserEvents() is a fresh instance each call. */
const userEventsPage = {page: 1};

export class UserEventsService extends ApiServiceBase {

    public async getBefore(): Promise<any> {
        userEventsPage.page = 1;
        const payload = await this.http?.get('/events/my', {page: 1, limit: 10});
        return normalizePaginated(payload).data;
    }

    public async getAfter(_eventId?: number): Promise<any> {
        userEventsPage.page += 1;
        const payload = await this.http?.get('/events/my', {page: userEventsPage.page, limit: 10});
        return normalizePaginated(payload).data;
    }

    public async get(eventId?: number): Promise<any> {
        return this.http?.get(`/events/${eventId}`);
    }
}
